<mat-dialog-content>
  <h2 mat-dialog-title>Crear Investigación</h2>
  <mat-tab-group [(selectedIndex)]="investigationType" mat-align-tabs="center">
    <mat-tab label="Busqueda por Caso">
      <div class="tab-body">
        <mat-form-field style="width: 100%;" appearance="outline" class="mt-3">
          <mat-label>Ingrese GAI del Caso</mat-label>
          <input matInput placeholder="Buscar" [formControl]="referenceInput" [matAutocomplete]="auto1">
          <mat-autocomplete #auto1="matAutocomplete">
            <mat-option *ngFor="let reference of casos" [value]="reference">{{ reference
              }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>Descripción de esta investigación</mat-label>
          <input matInput placeholder="Buscar" [(ngModel)]="descripcion">
        </mat-form-field>
        <mat-dialog-actions>
          <div class="button-container">
            <button mat-raised-button [disabled]="referenceInput.value == ''" color="primary"
              (click)="onCreateClick('caso')">Crear</button>
            <button mat-raised-button (click)="dialogRef.close()">Cancelar</button>
          </div>
        </mat-dialog-actions>
      </div>
    </mat-tab>
    <mat-tab label="Busqueda por Cédula">
      <div class="tab-body">
        <mat-form-field style="width: 100%;" appearance="outline" class="mt-3">
          <mat-label>Ingrese la Cédula</mat-label>
          <input matInput placeholder="Buscar" [formControl]="referenceInput" [matAutocomplete]="auto2">
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let reference of cedulas" [value]="reference">{{ reference
              }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>Descripción de esta investigación</mat-label>
          <input matInput placeholder="Buscar" [(ngModel)]="descripcion">
        </mat-form-field>
        <mat-dialog-actions>
          <div class="button-container">
            <button mat-raised-button color="primary" (click)="onCreateClick('cedula')">Crear</button>
            <button mat-raised-button (click)="dialogRef.close()">Cancelar</button>
          </div>
        </mat-dialog-actions>
      </div>
    </mat-tab>
    <mat-tab label="Busqueda por Cuenta">
      <div class="tab-body">
        <mat-form-field style="width: 100%;" appearance="outline" class="mt-3">
          <mat-label>Ingrese el número de cuenta</mat-label>
          <input matInput placeholder="Buscar" [formControl]="referenceInput" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let reference of cuentas" [value]="reference">{{ reference
              }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-label>Descripción de esta investigación</mat-label>
          <input matInput placeholder="Buscar" [(ngModel)]="descripcion">
        </mat-form-field>
        <mat-dialog-actions>
          <div class="button-container">
            <button mat-raised-button color="primary" (click)="onCreateClick('cuenta')">Crear</button>
            <button mat-raised-button (click)="dialogRef.close()">Cancelar</button>
          </div>
        </mat-dialog-actions>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>